import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowConsumerOfConditionsSchema, FlowConsumerOfDocumentExtractSchema, FlowConsumerOfLabValuesSchema, FlowConsumerOfMedicationsSchema, FlowConsumerOfSurgicalHistoriesSchema, } from '../consumer.js';
import { FlowBlockType } from '../type.js';
export const FlowHccAlgorithmBlockConfigSchema = z.object({
    agent: z.string(),
    // limiting to one sub flow for now
    flowDefinitionIds: z.array(z.string()).min(1).max(1),
    payload: z.object({
        documents: FlowConsumerOfDocumentExtractSchema,
        labValues: FlowConsumerOfLabValuesSchema,
        medications: FlowConsumerOfMedicationsSchema,
        problems: FlowConsumerOfConditionsSchema,
        procedures: FlowConsumerOfSurgicalHistoriesSchema,
    }),
});
export const FlowHccAlgorithmBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.HCCAlgorithmBlock),
    config: FlowHccAlgorithmBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.HccSkill),
});
//# sourceMappingURL=config.js.map